import { useState, useEffect, useRef } from 'react';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stylish%20flat%20lay%20composition%20featuring%20diverse%20fashion%20items%20including%20colorful%20sneakers%20a%20leather%20backpack%20folded%20denim%20jacket%20and%20minimal%20accessories%20arranged%20organically%20on%20a%20warm%20sand%20colored%20surface%20with%20gentle%20side%20lighting%20from%20a%20window%2C%20editorial%20product%20photography%20with%20rich%20natural%20textures%20and%20harmonious%20earth%20tones%2C%20sophisticated%20yet%20approachable%20lifestyle%20aesthetic&width=1600&height=900&seq=hero-bg-v2-2026&orientation=landscape"
          alt="Basetao Spreadsheet shopping resources and product discovery"
          title="Basetao Spreadsheet - Ultimate Shopping Resource Hub"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-8 text-center">
        <div className={`transition-all duration-800 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="inline-block px-4 py-1.5 mb-6 text-xs md:text-sm font-medium tracking-wider uppercase rounded-full bg-white/20 backdrop-blur-sm text-white border border-white/25">
            Updated 2026 Resources
          </span>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-semibold text-white leading-tight mb-6 max-w-3xl mx-auto">
            Basetao Spreadsheet &mdash; The Ultimate Resource For Smart Shopping
          </h1>

          <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-10 leading-relaxed">
            Discover the latest Basetao Spreadsheet collections, product finds, shopping guides, shipping information, reviews and exclusive resources. Make smarter buying decisions with our complete Basetao knowledge platform.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-label font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-300 hover:scale-105 cursor-pointer"
            >
              <i className="ri-shopping-bag-3-line text-lg"></i>
              basetao spreadsheet
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white/15 backdrop-blur-sm text-white border border-white/30 font-label font-semibold text-sm md:text-base hover:bg-white/25 transition-all duration-300 hover:scale-105 cursor-pointer"
            >
              <i className="ri-flashlight-line text-lg"></i>
              buy it now
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 mt-10 text-white/70 text-xs md:text-sm">
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-accent-400"></i>
              Updated 2026 Resources
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-accent-400"></i>
              Independent Shopping Guides
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-accent-400"></i>
              Verified Information
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-accent-400"></i>
              Beginner Friendly
            </span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/50 text-2xl"></i>
      </div>
    </section>
  );
}